var render = function render() {
  var _vm$State$config, _vm$State$config$feat;
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "commonPartyBox",
    staticClass: "common-party clearfix"
  }, [_c('main', {
    ref: "videoCanvas",
    class: {
      'main-width': _vm.showChatMessage || _vm.showAISpeech
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isallScrren,
      expression: "isallScrren"
    }],
    staticClass: "share-box flex"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('span', [_vm._v(_vm._s(_vm.behaviorInfo[_vm.shareInitiator]) + " " + _vm._s(_vm.$t('partylineGuest.isSharing')))]), _c('span', {
    staticClass: "check-share pointer",
    on: {
      "click": _vm.checkScreen
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('commonFunction.switchToParty')) + " ")])])]), _c('div', {
    staticClass: "contentBox scrollbar",
    class: [{
      mainwindow: _vm.outputRtilCode
    }, !_vm.outputRtilCode ? `noMainwindow` : '', `layout-${_vm.videoCanvasColumn}`, {
      fullScreen: _vm.State.fullScreen
    }, {
      noMaindowPadding: !_vm.outputRtilCode && _vm.rtilCodeList.length > 27 || _vm.outputRtilCode && _vm.rtilCodeList.length > 23
    }]
  }, [_c('div', {
    staticClass: "videoBox",
    class: {
      leftRight: _vm.State.commonHostLeftRight,
      chat: _vm.showChatMessage
    },
    style: {
      width: _vm.videoCanvasWidth
    }
  }, [_vm.State.commonHostLeftRight ? _c('singleSource', {
    key: _vm.leftRightRtilCode,
    ref: "leftRight",
    class: {
      leftRight: _vm.State.commonHostLeftRight,
      'zoomClass': _vm.showZoomClass
    },
    attrs: {
      "isAudioLevel": _vm.audioLevel,
      "devicePlatform": _vm.devicePlatform[_vm.leftRightRtilCode],
      "degreeHost": _vm.degreeHost[_vm.leftRightRtilCode],
      "anywherePopShow": _vm.anywhereSettingShowMap[_vm.leftRightRtilCode],
      "title": _vm.leftRightRtilCode + '',
      "nickName": _vm.behaviorInfo[_vm.leftRightRtilCode],
      "tagName": _vm.tagNameInfo[_vm.leftRightRtilCode],
      "singChannel": _vm.leftRightRtilCode == _vm.userInfo.rtilCode ? _vm.MeInfo : _vm.channels[_vm.leftRightRtilCode],
      "isAnyWhere": _vm.isAnyWhere[_vm.leftRightRtilCode],
      "wsInfo": _vm.wsInfoArray[_vm.leftRightRtilCode],
      "volume": _vm.voiceList[_vm.leftRightRtilCode] || {},
      "isallScrren": _vm.isallScrren,
      "rtilCodeList": _vm.rtilCodeList,
      "fullScreenInfo": _vm.fullScreenInfo[_vm.leftRightRtilCode],
      "selectRids": _vm.voipInfo[_vm.leftRightRtilCode] ? _vm.voipInfo[_vm.leftRightRtilCode] : '',
      "muteVideo": !_vm.State.cameraStatus[_vm.leftRightRtilCode],
      "muteAudio": !_vm.State.micStatus[_vm.leftRightRtilCode],
      "userInfo": _vm.userInfo,
      "leftRightRtilCode": _vm.leftRightRtilCode,
      "outputRtilCode": _vm.outputRtilCode + '',
      "remoteNetWorks": _vm.remoteNetWorks[_vm.leftRightRtilCode],
      "liveInfo": _vm.deviceStatusObj[_vm.leftRightRtilCode] && _vm.deviceStatusObj[_vm.leftRightRtilCode].type == 'T' ? _vm.deviceStatusObj[_vm.leftRightRtilCode] || {} : _vm.rtilStatusObj[_vm.leftRightRtilCode] || {},
      "talkbackStatus": _vm.talkbackStatus,
      "allRList": _vm.allRList,
      "rtcLoaded": _vm.rtcLoaded,
      "devicesInfo": _vm.otherMediaInfo[_vm.leftRightRtilCode],
      "talkBackInfo": _vm.talkBackInfo,
      "sourceType": _vm.rtilCodeKeyTypeVal[_vm.leftRightRtilCode],
      "controlMute": _vm.controlMuteInfo[_vm.leftRightRtilCode],
      "rtc": _vm.rtc
    },
    on: {
      "changeSourceList": _vm.changeSourceList,
      "changeR": _vm.changeR,
      "operatCallback": _vm.operateCallback,
      "changeRList": _vm.changeAllRList,
      "callBack": _vm.openliveAndLazyAudio
    }
  }, [_vm.leftRightRtilCode == _vm.userInfo.rtilCode && _vm.outputRtilCode != _vm.userInfo.rtilCode ? _c('div', {
    class: _vm.returnVideoClass,
    attrs: {
      "id": "local_stream"
    }
  }) : _vm._e()]) : _vm._e(), _vm.outputRtilCode && !_vm.State.commonHostLeftRight ? _c('SingleSource', {
    ref: "pgm",
    staticClass: "is-pgm",
    attrs: {
      "isAudioLevel": _vm.audioLevel,
      "devicePlatform": _vm.devicePlatform[_vm.outputRtilCode],
      "degreeHost": _vm.degreeHost[_vm.outputRtilCode],
      "title": _vm.outputRtilCode + '',
      "nickName": _vm.behaviorInfo[_vm.outputRtilCode],
      "tagName": _vm.tagNameInfo[_vm.outputRtilCode],
      "singChannel": _vm.channels[_vm.outputRtilCode],
      "wsInfo": _vm.wsInfoArray[_vm.outputRtilCode],
      "volume": _vm.voiceList[_vm.outputRtilCode] || {},
      "isallScrren": _vm.isallScrren,
      "fullScreenInfo": _vm.fullScreenInfo[_vm.outputRtilCode],
      "selectRids": _vm.voipInfo[_vm.outputRtilCode] ? _vm.voipInfo[_vm.outputRtilCode] : '',
      "muteVideo": !_vm.State.cameraStatus[_vm.outputRtilCode],
      "muteAudio": !_vm.State.micStatus[_vm.outputRtilCode],
      "userInfo": _vm.userInfo,
      "outputRtilCode": _vm.outputRtilCode + '',
      "remoteNetWorks": _vm.remoteNetWorks[_vm.outputRtilCode],
      "liveInfo": _vm.deviceStatusObj[_vm.outputRtilCode] && _vm.deviceStatusObj[_vm.outputRtilCode].type == 'T' ? _vm.deviceStatusObj[_vm.outputRtilCode] || {} : _vm.rtilStatusObj[_vm.outputRtilCode] || {},
      "talkbackStatus": _vm.talkbackStatus,
      "allRList": _vm.allRList,
      "rtcLoaded": _vm.rtcLoaded,
      "devicesInfo": _vm.otherMediaInfo[_vm.outputRtilCode],
      "talkBackInfo": _vm.talkBackInfo,
      "rtilCodeList": _vm.rtilCodeList,
      "sourceType": _vm.rtilCodeKeyTypeVal[_vm.outputRtilCode],
      "isAnyWhere": _vm.isAnyWhere[_vm.outputRtilCode],
      "controlMute": _vm.controlMuteInfo[_vm.outputRtilCode],
      "rtc": _vm.rtc,
      "hearSelf": _vm.hearSelf
    },
    on: {
      "changeSourceList": _vm.changeSourceList,
      "changeR": _vm.changeR,
      "operatCallback": _vm.operateCallback,
      "changeRList": _vm.changeAllRList,
      "callBack": _vm.openliveAndLazyAudio
    }
  }) : _vm._e(), _c('div', {
    staticClass: "clearfix pipContent scrollbar",
    class: {
      flexBox: !_vm.outputRtilCode,
      participantBox: _vm.State.commonHostLeftRight
    }
  }, [!_vm.noCameras && !_vm.setNameInfo.show && _vm.userInfo.rtilCode != _vm.outputRtilCode && _vm.leftRightRtilCode != _vm.MeInfo.id ? _c('SingleSource', {
    ref: "localSingleSource",
    attrs: {
      "degreeHost": _vm.degreeHost[_vm.MeInfo.id],
      "devicePlatform": _vm.devicePlatform[_vm.MeInfo.id],
      "title": "Me",
      "nickName": _vm.behaviorInfo[_vm.MeInfo.id] || '',
      "isallScrren": false,
      "wsInfo": _vm.wsInfoArray[_vm.MeInfo.id],
      "singChannel": _vm.MeInfo,
      "volume": _vm.voiceList[_vm.MeInfo.id],
      "allRList": _vm.allRList,
      "rtilCodeList": _vm.rtilCodeList,
      "muteVideo": !_vm.State.cameraStatus[_vm.userInfo.rtilCode],
      "muteAudio": !_vm.State.micStatus[_vm.userInfo.rtilCode],
      "needStartVoip": _vm.needStartVoip,
      "selectRids": _vm.voipInfo[_vm.MeInfo.id] ? _vm.voipInfo[_vm.MeInfo.id] : '',
      "sourceId": _vm.voipSourceIdList[_vm.MeInfo.id] ? _vm.voipSourceIdList[_vm.MeInfo.id] : '',
      "userInfo": _vm.userInfo,
      "liveInfo": _vm.deviceStatusObj[_vm.MeInfo.id] && _vm.deviceStatusObj[_vm.MeInfo.id].type == 'T' ? _vm.deviceStatusObj[_vm.MeInfo.id] || {} : _vm.rtilStatusObj[_vm.MeInfo.id] || {},
      "talkbackStatus": _vm.talkbackStatus,
      "talkBackInfo": _vm.talkBackInfo,
      "isAudioLevel": _vm.audioLevel,
      "controlMute": _vm.controlMuteInfo[_vm.MeInfo.id],
      "rtc": _vm.rtc,
      "hearSelf": _vm.hearSelf
    },
    on: {
      "operatCallback": _vm.operateCallback,
      "changeSourceList": _vm.changeSourceList,
      "changeR": _vm.changeR,
      "callBack": _vm.openliveAndLazyAudio
    }
  }, [_c('div', {
    class: _vm.returnVideoClass,
    attrs: {
      "id": "local_stream"
    }
  })]) : _vm._e(), _vm._l(_vm.rtilCodeList, function (rtilCode) {
    return _c('SingleSource', {
      key: rtilCode,
      ref: `remoteSingleSource${rtilCode}`,
      refInFor: true,
      attrs: {
        "isAudioLevel": _vm.audioLevel,
        "devicePlatform": _vm.devicePlatform[rtilCode],
        "degreeHost": _vm.degreeHost[rtilCode],
        "anywherePopShow": _vm.anywhereSettingShowMap[rtilCode],
        "title": rtilCode + '',
        "nickName": _vm.behaviorInfo[rtilCode],
        "tagName": _vm.tagNameInfo[rtilCode],
        "singChannel": _vm.channels[rtilCode],
        "isAnyWhere": _vm.isAnyWhere[rtilCode],
        "wsInfo": _vm.wsInfoArray[rtilCode],
        "volume": _vm.voiceList[rtilCode] || {},
        "isallScrren": _vm.isallScrren,
        "rtilCodeList": _vm.rtilCodeList,
        "fullScreenInfo": _vm.fullScreenInfo[rtilCode],
        "selectRids": _vm.voipInfo[rtilCode] ? _vm.voipInfo[rtilCode] : '',
        "muteVideo": !_vm.State.cameraStatus[rtilCode],
        "muteAudio": !_vm.State.micStatus[rtilCode],
        "userInfo": _vm.userInfo,
        "outputRtilCode": _vm.outputRtilCode + '',
        "remoteNetWorks": _vm.remoteNetWorks[rtilCode],
        "liveInfo": _vm.deviceStatusObj[rtilCode] && _vm.deviceStatusObj[rtilCode].type == 'T' ? _vm.deviceStatusObj[rtilCode] || {} : _vm.rtilStatusObj[rtilCode] || {},
        "talkbackStatus": _vm.talkbackStatus,
        "allRList": _vm.allRList,
        "rtcLoaded": _vm.rtcLoaded,
        "devicesInfo": _vm.otherMediaInfo[rtilCode],
        "talkBackInfo": _vm.talkBackInfo,
        "sourceType": _vm.rtilCodeKeyTypeVal[rtilCode],
        "controlMute": _vm.controlMuteInfo[rtilCode],
        "rtc": _vm.rtc
      },
      on: {
        "changeSourceList": _vm.changeSourceList,
        "changeR": _vm.changeR,
        "operatCallback": _vm.operateCallback,
        "changeRList": _vm.changeAllRList,
        "callBack": _vm.openliveAndLazyAudio
      }
    });
  })], 2)], 1)]), _vm.anyWhereInfo.show ? _c('anywhereSetting', {
    attrs: {
      "anyWhereSetObj": _vm.anyWhereSettings[_vm.anyWhereInfo.rtilCode],
      "degreeHost": _vm.degreeHost[_vm.anyWhereInfo.rtilCode],
      "peerId": _vm.anyWherePeerIds[_vm.anyWhereInfo.rtilCode],
      "platForm": _vm.anyWherePlatForms[_vm.anyWhereInfo.rtilCode],
      "singChannel": _vm.anyWhereVideoAudioInfo,
      "userInfo": _vm.userInfo,
      "info": _vm.anyWhereInfo,
      "partyCode": _vm.partyCode,
      "rtc": _vm.rtc
    },
    on: {
      "closeAnywherePreview": _vm.closeAnywherePreview
    }
  }) : _vm._e(), _vm.drawer ? _c('addPackReceiverJoin', {
    attrs: {
      "drawer": _vm.drawer,
      "partyCode": _vm.partyCode,
      "userInfo": _vm.userInfo,
      "channels": _vm.channels
    },
    on: {
      "close": function ($event) {
        _vm.drawer = false;
      }
    }
  }) : _vm._e(), _vm.setNameInfo.show ? _c('user-setting', {
    attrs: {
      "info": _vm.setNameInfo
    },
    on: {
      "setNickName": _vm.setNickName
    }
  }) : _vm._e(), _vm.Vfb.show ? _c('select-source-type', {
    attrs: {
      "info": _vm.Vfb
    },
    on: {
      "updateVfbData": _vm.updateSourceData
    }
  }) : _vm._e(), _c('guide-page', {
    attrs: {
      "dialogVisible": _vm.State.guideObjShow
    }
  }), _vm.setTagName.show ? _c('tag-name', {
    attrs: {
      "info": _vm.setTagName
    },
    on: {
      "saveTagName": _vm.saveTagName
    }
  }) : _vm._e(), _vm.movePartyInfo.show ? _c('MovePartyList', {
    attrs: {
      "info": _vm.movePartyInfo,
      "userInfo": _vm.userInfo,
      "devicePlatform": _vm.devicePlatform
    }
  }) : _vm._e(), _vm.batchMovePartyInfo.show ? _c('MovePartyTips', {
    attrs: {
      "info": _vm.batchMovePartyInfo,
      "userInfo": _vm.userInfo
    }
  }) : _vm._e()], 1), _c('Foot', {
    ref: "footDiv",
    staticClass: "bottom-foot",
    attrs: {
      "isShare": _vm.isShare,
      "camera": _vm.State.cameraStatus[_vm.userInfo.rtilCode],
      "mic": _vm.State.micStatus[_vm.userInfo.rtilCode],
      "talkBackInfo": _vm.talkBackInfo,
      "liveInfo": _vm.deviceStatusObj[_vm.rtilCode] && _vm.deviceStatusObj[_vm.rtilCode].type == 'T' ? _vm.deviceStatusObj[_vm.rtilCode] || {} : _vm.rtilStatusObj[_vm.rtilCode] || {},
      "rtcLoaded": _vm.rtcLoaded,
      "showUnread": _vm.showUnread,
      "devicesInfo": _vm.devicesInfo,
      "startHearSelf": _vm.startHearSelf,
      "userInfo": _vm.userInfo,
      "rtilCode": _vm.rtilCode,
      "localVolume": _vm.localVolume,
      "cameraDevice": _vm.devicesInfo.cameraList,
      "speakerDevice": _vm.devicesInfo.speakerList,
      "showIconArray": _vm.iconList,
      "microphoneDevice": _vm.devicesInfo.microphoneList,
      "isHost": true,
      "rtc": _vm.rtc,
      "osLevelmicMuted": _vm.osLevelmicMuted
    },
    on: {
      "eventCallback": _vm.dealFootEvent,
      "handleMouseDown": _vm.listenerKeyDown,
      "handleMouseUp": _vm.listenerKeyUp
    }
  }), _vm.userInfo.rtilCode && _vm.loadChatBox ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showChatMessage,
      expression: "showChatMessage"
    }],
    staticClass: "chatBox"
  }, [_c('ChatMessage', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showChatMessage,
      expression: "showChatMessage"
    }],
    attrs: {
      "userInfo": _vm.userInfo,
      "allPartyMembers": _vm.allPartyMembers,
      "chatPartyCode": _vm.userInfo.realPartyCode,
      "showComponent": _vm.showChatMessage,
      "nickNameInfo": _vm.behaviorInfo,
      "tagNameInfo": _vm.tagNameInfo
    },
    on: {
      "callback": _vm.chatCallback
    }
  })], 1) : _vm._e(), _vm.showAISpeech && (_vm$State$config = _vm.State.config) !== null && _vm$State$config !== void 0 && (_vm$State$config$feat = _vm$State$config.features) !== null && _vm$State$config$feat !== void 0 && _vm$State$config$feat.stt ? _c('aiSpeech', {
    ref: "aiSpeech",
    attrs: {
      "behaviorInfo": _vm.behaviorInfo,
      "summaryLanguage": _vm.translateInto,
      "userInfo": _vm.userInfo,
      "partyCode": _vm.partyCode,
      "sttHistoryList": _vm.sttHistoryList,
      "sttRtilCode": _vm.sttRtilCode,
      "showAISpeech": _vm.showAISpeech,
      "rtilCodeKeyTypeVal": _vm.rtilCodeKeyTypeVal
    }
  }) : _vm._e(), _vm.State.aiBotFeature && _vm.State.aiBotEnable && _vm.State.showAIBot ? _c('aiBot') : _vm._e(), _c('tipsDailog', {
    staticClass: "collaboratePopup",
    attrs: {
      "info": _vm.collaborateInfo,
      "width": "640px"
    },
    on: {
      "save": function ($event) {
        return _vm.controlInvite(true);
      },
      "cancel": function ($event) {
        return _vm.controlInvite(false);
      }
    }
  }, [_c('div', {
    staticClass: "email",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "-2px"
    }
  }, [_c('p', [_c('img', {
    attrs: {
      "src": "https://dl.tvunetworks.com/static/partyline/image/people.png"
    }
  })])]), _c('div', [_c('p', {
    staticStyle: {
      "color": "#4A90E2",
      "text-decoration": "underline"
    }
  }, [_vm._v(_vm._s(_vm.collaborateInfo.info.fromEmail))]), _c('p', [_vm._v(" " + _vm._s(_vm.$t('personalInfo.collaboratePopupLike')))])])]), _c('div', {
    staticClass: "popupContent",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "color": "#28282E"
    }
  }, [_vm._v(_vm._s(_vm.$t('personalInfo.collaboratePopupAllow')))]), _c('p', [_vm._v(_vm._s(_vm.$t('personalInfo.collaboratePopupDetail1')))]), _c('p', [_vm._v(_vm._s(_vm.$t('personalInfo.collaboratePopupDetail2')))]), _c('p', [_vm._v(_vm._s(_vm.$t('personalInfo.collaboratePopupDetail3')))])])])]), _c('tipsDailog', {
    staticClass: "collaboratePopup",
    attrs: {
      "info": _vm.coHostInfo,
      "width": "640px"
    },
    on: {
      "save": function ($event) {
        return _vm.controlCohostInvite(true);
      },
      "cancel": function ($event) {
        return _vm.controlCohostInvite(false);
      }
    }
  }, [_c('div', {
    staticClass: "email",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "-2px"
    }
  }, [_c('p', [_c('img', {
    attrs: {
      "src": "https://dl.tvunetworks.com/static/partyline/image/people.png"
    }
  })])]), _c('div', [_c('p', {
    staticStyle: {
      "color": "#4A90E2",
      "text-decoration": "underline"
    }
  }, [_vm._v(_vm._s(_vm.coHostInfo.info.fromEmail))]), _c('p', [_vm._v(" " + _vm._s(_vm.$t('personalInfo.cohostPopupLike')) + " ")]), _c('p', {
    staticStyle: {
      "color": "#4A90E2",
      "text-decoration": "underline"
    }
  }, [_vm._v("\"" + _vm._s(_vm.coHostInfo.info.PartyName ? _vm.coHostInfo.info.PartyName : 'ID:' + _vm.coHostInfo.info.PartyCode) + "\" ")]), _c('p', [_vm._v(_vm._s(_vm.$t('personalInfo.cohostPopupParty')))])])]), _c('div', {
    staticClass: "popupContent",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "color": "#28282E"
    }
  }, [_vm._v(_vm._s(_vm.$t('personalInfo.collaboratePopupAllow')))]), _c('p', [_vm._v(_vm._s(_vm.$t('personalInfo.cohostPopupDetail1')))]), _c('p', [_vm._v(_vm._s(_vm.$t('personalInfo.cohostPopupDetail2')))])])])]), _c('tipsDailog', {
    staticClass: "collaboratePopup",
    attrs: {
      "info": _vm.coHostLimit,
      "width": "640px"
    },
    on: {
      "save": function ($event) {
        return _vm.controlCohostLimit(true);
      },
      "cancel": function ($event) {
        return _vm.controlCohostLimit(false);
      }
    }
  }, [_c('div', {
    staticClass: "email"
  }, [_c('img', {
    attrs: {
      "src": "https://dl.tvunetworks.com/static/partyline/image/people.png"
    }
  }), _c('span', [_vm._v(_vm._s('The number of co-hosts has reached the maximum number, would you like to join as a participant?'))])])]), _c('tipsDailog', {
    staticClass: "repeatJoin",
    attrs: {
      "width": "550px",
      "info": _vm.repeatInfo
    },
    on: {
      "save": function ($event) {
        _vm.repeatInfo.show = false;
      }
    }
  }, [_c('div', {
    staticClass: "email"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('common.repeatContent')))])])]), _c('TipsDailog', {
    attrs: {
      "info": _vm.CameraTips,
      "showClose": false
    },
    on: {
      "save": _vm.setCameraStatus,
      "cancel": () => {
        _vm.sendToHost('camera', 2);
      }
    }
  }), _c('tipsDailog', {
    staticClass: "controlMediaPopup",
    attrs: {
      "info": _vm.controlMediaInfo,
      "width": "640px"
    },
    on: {
      "save": function ($event) {
        return _vm.controlModify(true);
      },
      "cancel": function ($event) {
        return _vm.controlModify(false);
      }
    }
  }, [_c('div', {
    staticClass: "email"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('common.theHost')) + " "), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.controlMediaInfo.info.email))]), _vm._v(" " + _vm._s(_vm.$t('common.mediaPopupText')))])])]), _c('tipsDailog', {
    staticClass: "summary",
    attrs: {
      "info": _vm.State.summaryInfo,
      "width": "500"
    },
    on: {
      "close": function ($event) {
        _vm.State.summaryInfo.contentText = '';
      }
    }
  }, [_c('div', {
    staticClass: "header",
    attrs: {
      "slot": "head"
    },
    slot: "head"
  }, [_c('div', {
    staticClass: "headLeft"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('aiSpeech.aiSummary')))])]), _c('div', {
    staticClass: "headRight"
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top",
      "content": _vm.$t('commonPartyHost.topContent.send')
    }
  }, [_c('i', {
    staticClass: "iconfont icon-xingzhuang pointer",
    style: {
      'font-size': '15px'
    },
    on: {
      "click": function ($event) {
        _vm.sendEmailInfo.show = true;
      }
    }
  })]), _c('el-divider', {
    staticClass: "gray",
    attrs: {
      "direction": "vertical"
    }
  }), _c('el-tooltip', {
    attrs: {
      "placement": "top",
      "content": _vm.$t('commonPartyHost.topContent.copy')
    }
  }, [_c('i', {
    staticClass: "iconfont icon-log pointer",
    on: {
      "click": _vm.copySummary
    }
  })]), _c('el-divider', {
    staticClass: "gray",
    attrs: {
      "direction": "vertical"
    }
  }), _c('el-tooltip', {
    attrs: {
      "placement": "top",
      "content": _vm.$t('aiSpeech.download')
    }
  }, [_c('i', {
    staticClass: "iconfont icon-xiazai pointer",
    on: {
      "click": _vm.downloadSummary
    }
  })]), _c('el-divider', {
    staticClass: "gray",
    attrs: {
      "direction": "vertical"
    }
  }), _c('el-popover', {
    attrs: {
      "placement": "bottom",
      "popper-class": "translateSetting",
      "width": "260",
      "trigger": "click"
    },
    model: {
      value: _vm.showTranslate,
      callback: function ($$v) {
        _vm.showTranslate = $$v;
      },
      expression: "showTranslate"
    }
  }, [_c('div', {
    staticClass: "translate"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('aiSpeech.translateInto')))]), _c('el-radio-group', {
    on: {
      "change": _vm.sendTranslate
    },
    model: {
      value: _vm.translateInto,
      callback: function ($$v) {
        _vm.translateInto = $$v;
      },
      expression: "translateInto"
    }
  }, _vm._l(_vm.langArray, function (lang) {
    return _c('el-radio', {
      key: lang.val,
      staticClass: "green",
      attrs: {
        "label": lang.val
      }
    }, [_vm._v(_vm._s(lang.label))]);
  }), 1)], 1), _c('el-tooltip', {
    attrs: {
      "slot": "reference",
      "placement": "top",
      "content": _vm.$t('aiSpeech.translate')
    },
    slot: "reference"
  }, [_c('i', {
    staticClass: "iconfont icon-translate pointer",
    style: {
      color: _vm.showTranslate ? '#33AB4F' : ''
    }
  })])], 1), _c('el-divider', {
    staticClass: "gray secondDivider",
    attrs: {
      "direction": "vertical"
    }
  })], 1)]), _c('div', {
    staticClass: "content"
  }, [_vm.State.summaryInfo.loading ? _c('div', {
    staticClass: "default"
  }, [_c('speechBarAnimation'), _c('span', [_vm._v(_vm._s(_vm.$t('voiceCommand.summaryGenerate')))])], 1) : _c('div', {
    staticClass: "summaryText scrollbar"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.formattedText)
    }
  })])])]), _c('tipsDailog', {
    staticClass: "deviceDetail",
    attrs: {
      "info": _vm.deviceDetailInfo,
      "width": "640px"
    }
  }, [_c('deviceDetail', {
    attrs: {
      "detail": _vm.detailObj,
      "partyCode": _vm.partyCode,
      "deviceDetailInfo": _vm.deviceDetailInfo
    }
  })], 1), _c('tipsDailog', {
    staticClass: "aiPolicy",
    attrs: {
      "info": _vm.aiPolicyInfo,
      "width": "640px"
    },
    on: {
      "notRemind": _vm.notRemind,
      "save": function ($event) {
        _vm.aiPolicyInfo.show = false;
      }
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('aiSpeech.aiPolicyGeneratedText')))]), _c('p', [_vm._v(_vm._s(_vm.$t('aiSpeech.aiPolicyModelText')))]), _c('p', [_vm._v(_vm._s(_vm.$t('aiSpeech.aiPolicyAccuracyText')))])])]), _c('tipsDailog', {
    staticClass: "liveAndLazyAudio",
    attrs: {
      "info": _vm.liveAndLazyAudioInfo,
      "width": "640px"
    },
    on: {
      "save": function ($event) {
        _vm.liveAndLazyAudioInfo.show = false;
      }
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('common.liveAndLazyAudioText')))])])]), _c('tipsDailog', {
    staticClass: "sendEmail",
    attrs: {
      "info": _vm.sendEmailInfo,
      "width": "640px"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('span', {
    staticClass: "headTitle"
  }, [_vm._v(_vm._s(_vm.$t('common.sendSetting')))]), _c('el-tooltip', {
    attrs: {
      "placement": "top",
      "content": _vm.$t('setting.settingName')
    }
  }, [_c('i', {
    staticClass: "iconfont tvu-icon-a-help1 pointer",
    on: {
      "click": _vm.showSpeechSetting
    }
  })])], 1), _c('div', {
    staticClass: "content"
  }, _vm._l(_vm.emailList, function (item) {
    return _c('div', {
      key: item.title,
      staticClass: "emailLi"
    }, [_c('div', {
      staticClass: "title"
    }, [_c('span', {
      staticClass: "emailTitle"
    }, [_vm._v(_vm._s(_vm.$t(`aiSpeech.${item.title}`)))]), _c('el-tooltip', {
      attrs: {
        "placement": "top"
      }
    }, [_c('div', {
      attrs: {
        "slot": "content"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.returnEmailTips(item.title))
      },
      slot: "content"
    }), _c('i', {
      staticClass: "iconfont icon-help2"
    })])], 1), _vm.sendEmailInfo.show ? _c('emailInput', {
      attrs: {
        "partyCode": _vm.userInfo.joinCode,
        "type": item.title
      },
      on: {
        "addEmail": _vm.addEmail,
        "deleteEmail": _vm.deleteEmail
      },
      model: {
        value: item.value,
        callback: function ($$v) {
          _vm.$set(item, "value", $$v);
        },
        expression: "item.value"
      }
    }) : _vm._e()], 1);
  }), 0), _c('div', {
    staticClass: "emailFoot",
    attrs: {
      "slot": "foot"
    },
    slot: "foot"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showSavingTips,
      expression: "showSavingTips"
    }],
    staticClass: "emailText"
  }, [_vm._v(_vm._s(_vm.returnSavingEmailText))]), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sendEmail
    }
  }, [_vm._v(_vm._s(_vm.$t('commonPartyHost.topContent.send')))])], 1)]), _c('tipsDailog', {
    staticClass: "micMuted",
    attrs: {
      "info": _vm.showMicMutedInfo,
      "width": "560px"
    }
  }, [_c('div', {
    staticClass: "micMutedContent"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('micMutedInfo.contentTitle')))]), _c('div', {
    staticClass: "message"
  }, [_vm._v(_vm._s(_vm.$t('micMutedInfo.contentMessage')))]), _c('span', {
    staticClass: "openMicBtn",
    on: {
      "click": _vm.openMicMuted
    }
  }, [_vm._v(_vm._s(_vm.$t('micMutedInfo.openBtnMes')))])])]), _c('canvas', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    staticStyle: {
      "position": "absolute",
      "top": "0"
    },
    attrs: {
      "id": "mirrorLocal",
      "width": "480",
      "height": "270"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };